/**
 * created by lei lei
 * 横向管控媒体内容管理
 *
 */
import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from "react-custom-scrollbars";
import { Button, Input, Select, Tabs, DatePicker, Popover, message, Icon, Checkbox, Row, Col, Radio,Table } from "antd";
import './ContentManagement.css'
import moment from 'moment';
import *as utils from '../../../../utils'
import weChat from "./img/wechat.png";
import microBlog from "./img/microBlog.png";
import tiktok from "./img/tiktok.png";
import website from "./img/website.png";
import led from "./img/led.png";
import * as Action from '../../actions/horizontalManagement'
import { connect } from "react-redux";
import PageTemplate from "../../components/pageTemplate/PageTemplate";
import TableTemplate from "../../components/TableTemplate/TableTemplate";
import TabsTemplate from "../../components/TabsTemplate/TabsTemplate";
import PaginationTemplate from "../../components/PaginationTemplate/PaginationTemplate";
import PositionLevel from "../positionStatisticAnalysis/components/positionLevel";
import Sta_Date from "../positionOverview/components/sta_Date";
import TitleAndPicReview from '../contenManagement/child/titleAndPicReview/titleAndPicReview'
import RenderPicker from './components/renderPicker/RenderPicker'
import {formatTime,formatCount} from "../../../../utils";
import copy from 'copy-to-clipboard';
import ContentShow from "../../../positionManage/components/list/historicalRelease/components/contentShow";
import MediaTypeTabs from './components/mediaTypeTabs/MediaTypeTabs';
import SortWay from '../../../positionManage/components/list/sortWay/sortWay';
import ChangeCollectFolder from './components/changeCollectFolder/ChangeCollectFolder';
import { successCollect } from './components/successCollect/SuccessCollect';
import collected from './img/collected.png'
import BaseComponent from '../../../../base/BaseComponent';

const { Option } = Select;
const { Search } = Input;
const { TabPane } = Tabs;

const iconToPic = {"website":website,"weChat":weChat,"microBlog":microBlog,"tiktok":tiktok,"led":led}

const { MonthPicker, RangePicker } = DatePicker;

const dateFormat = 'YYYY-MM-DD';
export default class ContentManagement extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.Actions = Action;
        this.state = {
            mediaType: 2,//媒体
            typeId: "",
            allDepartmentsData:[],//所有部门
            deptId:'',//当前选中的部门
            searchText:'',//搜索的文字，
            grade:'',
            page:1,
            size:10,
            startDate:'',
            endDate:'',
            dataSource:[],
            count:0,
            selectDateConfig : {
                defaultKey:'近一周',
                selectConfig:['昨天','前天', '近一周', '时间不限']
            },
            folderVisible: false,
            // collectFolderData:[],
            currentRecord:{},//当前选中的记录
            follow: false,
            collectNum:0,  //收藏文章总数
            codes:[],
            screenHeight: 52
        };
        this.getCurrentUserMediaList();
        this.collectMsgTimeId = null;
    }

    componentWillMount() {
        this.getTabs();
        if (this.permissionCheck("pms:positionManage:all")) {
            this.getDeptAll()
        }else{
            this.getCurrentDeptByIds()
        }

    }
    searchRef = React.createRef();
    componentDidMount() {
        const observer = new ResizeObserver(e=>{
            e.forEach(entry=>{
                if(entry.contentRect.height !== this.state.screenHeight) {
                    this.setState({screenHeight: entry.target.offsetHeight})
                }
            });
        });
        if (this.searchRef.current) {
            observer.observe(this.searchRef.current)
        }
        this.setState({
            dataSource:[]
        });
    }

    getCollected = () => {
        this.request({
            url: "/cm-sites-media-consumer/collect/collectiontypeList",
            callBack: (data) => {
                let num = 0;
                if(data && data.length) {
                    data.forEach(item => {
                        num = num + item.articleNum;
                    })
                    this.setState({
                        collectNum:num
                    })
                }
            }
        })
    }
    getTabs = () =>{
        this.request({
            url: '/cm-sites-media-consumer/position/content/manager/getPositionType',
            method: "get",
            callBack: (data) => {
                let secondaryTabs = [];
                if(data&&data.length){
                    data.forEach((item,index)=>{
                        secondaryTabs.push({
                            key: item.name,
                            src: item.logo,
                            ...item
                        })
                    });
                }
                this.setState({secondaryTabs},()=>{
                    this.getList()
                })
            }
        });
    };

    getList = () =>{
        let {secondaryTabs,mediaType} =this.state;
        let newData = secondaryTabs&&secondaryTabs.length&&secondaryTabs.filter(item=> item.type === mediaType);
        if(newData&&newData.length){
            let params ={
                "codes": this.state.codes,
                "deptId": this.state.deptId,
                "endDate": this.state.endDate?new Date(this.state.endDate).getTime():'',
                "grade": this.state.grade,
                "keyWord": this.state.searchText,
                "page": this.state.page,
                "size": this.state.size,
                "startDate":this.state.startDate?new Date(this.state.startDate).getTime():'',
                "typeId": this.state.typeId || newData[0].id || '',
                "follow": this.state.follow
            };
            if(mediaType === 2) {
                let sortObj = this.sortWay.getData();
                params = {...params,...sortObj}
            }
            this.request({
                url: '/cm-sites-media-consumer/position/content/manager/list',
                method: "post",
                body: params,
                contentType: 'json',
                callBack: (data) => {
                    let count = data.count;
                    let dataSource = [];
                    if(data&&data.data&&data.data.length){
                        dataSource = data.data
                    }
                    this.setState({dataSource,count})
                }
            });
        }
        this.getCollected();
    };

   //获取全部单位
    getDeptAll = ( ) =>{
        this.request({
            url: "/cm-sites-sys/dept/getAll",
            method:"GET",
            callBack: (res) => {
                let allDepartmentsData = [];
                if(res && res.length){
                    allDepartmentsData = res.filter(item => item.id !== "0");
                }
                this.setState({allDepartmentsData})
            },
            errorCallBack: (e) => {
            },
        })
    };

    //获取自己所在单位
    getCurrentDeptByIds = () =>{
        this.request({
            url: "/cm-sites-sys/dept/getByIds",
            contentType: "json",
            body: window.top.currentUser.deptIds,
            method:"post",
            callBack: (res) => {
                if(res){
                    this.setState({allDepartmentsData:res})
                }
            },
            errorCallBack: (e) => {
            },
        })
    };


    //重置
    revert = () =>{
        this.state.searchText = '';
        this.state.deptId = '';
        // this.state.endDate = '';
        // this.state.startDate = '';
        this.state.follow = false;
        this.state.codes = [];
        this.state.isAcademy = undefined
        this.staDate.revert(this.state.selectDateConfig.defaultKey);
        this.sortWay.reset();
        this.setState({}, () => {
            // this.getList();
            this.staDate.showData(this.state.selectDateConfig.defaultKey)
        })
    };

    view = (data) => {
        const mediaData = this.state.secondaryTabs?.find(item => item.id === data.positionTypeId);
        if (mediaData.type === 1) {
            utils.openNewWindow(data.url);
        } else {
            window.openPage({
                url: window.framereactPath + "index.html#/newMedia/contentManagement/viewContent",
                params: {...data, mediaData},
            })
        }
    }

    //下载
    downLoad = (record) =>{
        let {secondaryTabs,mediaType} =this.state;
        let newData = secondaryTabs&&secondaryTabs.length&&secondaryTabs.filter(item=> item.type === mediaType);
        if(newData&&newData.length){
            this.request({
                url: '/cm-sites-media-consumer/position/content/manager/downloadById',
                method: "downloadGet",
                body: {
                    contentId:record.contentId,
                    typeId:newData?newData[0].id:''
                },
                contentType: 'json',
                callBack: (data) => {

                }
            });
        }

    };

    //复制
    copyText = (data) => {
        copy(data.url);
        message.success('复制成功')
    };

    //切换翻页
    onPageChange = ({current, pageSize}) => {
        this.state.size = pageSize;
        this.state.page = current;
        this.getList()
    };

    //切换一页展示多少条数据
    onShowSizeChange= ({current, pageSize}) => {
        this.state.size = pageSize;
        this.state.page = 1;
        this.getList()
    };

    //点击最新文章标题
    itemClick(record) {
        if (record.url) {
            window.open(record.url);
        }else {
            this.contentShowRef.open(record);
        }
    }

    render() {
        return (
            <div style={{background: 'white',maxHeight: 'calc(100vh - 100px)',marginTop:15,borderRadius: "5px"}} className={'ContenManagement'}>
                    {this.renderTabs()}
                    {this.renderScreen()}
                    {this.renderTable()}
                    <ContentShow  ref={(ComponentsList) => {
                        this.contentShowRef = ComponentsList
                    }}/>
                    <ChangeCollectFolder
                    visible={this.state.folderVisible}
                    // data={this.state.collectFolderData}
                    saveArticle={this.saveArticle}
                    cancelCollect={this.deleteCollectionArticle}
                    cancel={() => {
                        this.setState({ folderVisible: false })
                    }}
                    refreshData={this.getCollectionFileList}
                    />
                    <Button type='link' className='wechatCollectArticle' onClick={() => {
                        this.props.history.push('/newMedia/contentManagement/weChatCollectArticle')
                    }}>
                        <img src={collected} style={{width: 20,height: 20, marginRight: 5, transform:'translateY(-2px)'}}/>
                        微信文章收藏({this.state.collectNum})&nbsp;&nbsp;&nbsp;&gt;
                    </Button>
            </div>
        )
    }

    renderTabs = () => {
        return (
                <PositionLevel
                    callBack={(data) => {
                        this.state.grade = data;
                        this.state.size = 10;
                        this.state.page = 1;
                        this.setState({},()=>{
                            this.getList()
                        })
                    }}>
                </PositionLevel>

        )
    };

    refreshList() {
        this.getList()
    }


    //渲染筛选条件
    renderScreen() {
        let isWechat = this.state.mediaType === 2;
        let defaultValue = this.state.secondaryTabs ? this.state.secondaryTabs.find(item => item.type === 2)?.id : undefined;
        return (
            <PageTemplate style={{ padding: '0px 15px', }} styleOut={{ marginTop: 15 }}>
                {/* <Scrollbars style={{ height: '70px' }}> */}
                    <div ref={this.searchRef} className={"screen"} style={{
                        display: 'flex',
                        justifyContent: 'start',
                        alignItems: "center",
                        flexWrap: 'wrap',
                    }}>
                        <Select
                            placeholder={'媒体平台'}
                            value={this.state.typeId || defaultValue}
                            style={{ width: '130px', margin: '10px 0 10px 10px' }}
                            onChange={(val) => {
                                const selectedItem = this.state.secondaryTabs && this.state.secondaryTabs.find(item => item.id === val);
                                this.state.typeId = val;
                                this.state.mediaType = selectedItem?.type;
                                this.state.page = 1;
                                this.state.size = 10;
                                this.state.selectDateConfig.defaultKey = '近一周';
                                this.setState({}, () => {
                                    this.getList()
                                })
                            }}>
                            {this.state.secondaryTabs && this.state.secondaryTabs.length && this.state.secondaryTabs.map((item, i) => {
                                return (
                                    <Option title={item.name} key={item.id} value={item.id}>{item.name}</Option>
                                )
                            })
                            }
                        </Select>
                        <Select
                            showSearch
                            optionFilterProp="children"
                            placeholder={'主责单位'}
                            allowClear
                            value={this.state.deptId ? this.state.deptId : undefined}
                            style={{ width: '150px', margin: '10px' }}
                            onChange={(e) => {
                                this.state.deptId = e;
                                this.state.page = 1;
                                this.state.size = 10;
                                this.setState({}, () => {
                                    this.getList()
                                })
                            }}>
                            {this.state.allDepartmentsData && this.state.allDepartmentsData.length && this.state.allDepartmentsData.map((item, i) => {
                                return (
                                    <Option title={item.name} key={i} value={item.id}>{item.name}</Option>
                                )
                            })
                            }
                        </Select>
                        <Sta_Date
                            // key={"StaDate" + this.state.mediaType}
                            ref={(ComponentsList) => {
                                this.staDate = ComponentsList
                            }}
                            allowClear={true}
                            config={this.state.selectDateConfig} callBack={(start, end, btnText) => {
                                this.setState({
                                    ...this.state,
                                    startDate: start,
                                    endDate: end,
                                    page: 1,
                                    size: 10
                                }, () => {
                                    this.getList()
                                });

                            }}>
                        </Sta_Date>
                        {
                            this.state.mediaType === 2 &&
                            <div style={{ margin: '10px' }}>
                                <Radio.Group value={this.state.follow} onChange={(e) => {
                                    this.setState({
                                        follow: e.target.value
                                    },() => {
                                        this.getList();
                                    })
                                }}>
                                    <Radio.Button value={false}>查看全部</Radio.Button>
                                    <Radio.Button value={true}>仅看重点关注</Radio.Button>
                                </Radio.Group>
                            </div>
                        }
                        <div className={isWechat ? "screen-component" : ""}>
                            <SortWay isShow={this.state.mediaType === 2} ref={ref => this.sortWay = ref} defaultValue="count" options={
                                [{
                                    key: 'count',
                                    value: 'count',
                                    label: '按阅读数排序'
                                }, {
                                    key: 'publishTime',
                                    value: 'publishTime',
                                    label: '按发布时间排序'
                                }]
                            } refreshList={() => this.refreshList()} width={120} />
                        </div>
                        <div className={isWechat ? "screen-component" : ""}>
                            <Search
                                placeholder="请输入标题关键词"
                                style={{ width: '180px', margin: '10px 0 10px 10px' }}
                                size="default"
                                value={this.state.searchText}
                                onChange={(e) => {
                                    this.setState({
                                        searchText: e.target.value
                                    });
                                }}
                                allowClear
                                onSearch={value => {
                                    this.state.searchText = value;
                                    this.state.page = 1;
                                    this.state.size = 10;
                                    this.getList();
                                }}
                            />
                        </div>
                        <Button className={isWechat ? "screen-component" : ""} style={{ margin: '10px 0 10px 10px' }} onClick={() => {
                            this.revert()
                        }}>重置</Button>
                        <style>{`
                                .screen .ant-select-selection{border: 1px solid #eef2fb !important; background-color: #f5f8fc !important;}
                                .screen .ant-input-affix-wrapper .ant-input{border: 1px solid #eef2fb !important; background-color: #f5f8fc !important;}
                            `}</style>
                    </div>
                {/* </Scrollbars> */}

            </PageTemplate>
        )
    }

    noNeedMediaTypeCodes = ["material"];

    getCurrentUserMediaList = ()=>{
        this.request({
            url : "/cm-sites-pms/media/getCurrentUserMediaGroupByType",
            callBack: (data)=>{
                // 过滤禁用的媒体
                let newData = data?.length && data.filter(item => !this.noNeedMediaTypeCodes.includes(item.mediaTypeCode)).map(item=>({
                    ...item,
                    mediaList: item.mediaList && item.mediaList.filter(media=>{
                        return  media.disable == 0;
                    })
                }));
                // 素材中心这里只保留网站和微信稿件
                if(newData){
                    let mediaTypes = this.sysConfigGetValueByKey("contentManage.shiqu.media.type", "webNews,material,rmapp").split(",");
                    newData = newData.filter(item=>{
                        return mediaTypes.indexOf(item.mediaTypeCode) > -1;
                    });
                }
                this.setState({
                    treeData: newData
                });
            }
        })
    };

    // 收藏成功提示框
    openCollectedMessage = () => {
        let that = this;
        successCollect(() => {
            that.setState({
                folderVisible: true
            })
        })
    }
    // 获取收藏夹列表
    getCollectionFileList = () => {
        return new Promise((resolve, reject) => {
            this.request({
                url: "/cm-sites-media-consumer/collect/collectiontypeList",
                callBack: (data) => {
                    // this.setState({
                    //     collectFolderData: data
                    // })
                    resolve(data);
                },
                errorCallBack: (err) => {
                    reject(err);
                }
            })
        })
    }

    // 收藏文章接口
    saveArticle = ({positionContentVo, collectTypeIds, callBack}) => {

        this.request({
            url: "/cm-sites-media-consumer/collect/saveCollectArticle",
            method: "post",
            contentType: 'json',
            body: {
                collectTypeIds,
                positionContentVo: positionContentVo ? {...positionContentVo, collect: true} :{ ...this.state.currentRecord, collect: true}
            },
            callBack: (res) => {
                if(res.id) {
                    this.getList();
                    callBack && callBack();
                }
            }
        })
    }
    // 取消收藏接口
    deleteCollectionArticle = (articleId) => {
        this.request({
            url: "/cm-sites-media-consumer/collect/deleteCollectArticle",
            method: "get",
            body: {
                articleId: articleId ? articleId : this.state.currentRecord.contentId
            },
            callBack: (res) => {
                if(res) {
                    if(window.collectMsgTimeId) {
                        clearInterval(window.collectMsgTimeId);
                    }
                    message.destroy();
                    message.success("已取消收藏");
                    this.getList();
                }
            }
        })
    }
    // 收藏文章
    collectionArticle = async (record) => {
        this.setState({
            currentRecord: record
        });
        if(record.collect) {
            this.deleteCollectionArticle(record.contentId);
        } else {
            const collectionFileList = await this.getCollectionFileList();
            const defaultCollectionFolderId = collectionFileList && collectionFileList.find(item => item.stats === 0).id;
            this.saveArticle({
                positionContentVo: record, collectTypeIds: [defaultCollectionFolderId], callBack: () => {
                    message.destroy();
                    // this.getCollectionFileList();
                    this.openCollectedMessage();
                }
            });
        }
    }
    // 关注账号
    followAccount = (mediaCode, follow) => {
        this.request({
            url:'/cm-sites-media-consumer/position/content/manager/follow',
            method: 'post',
            body:{
                follow,
                mediaCode
            },
            callBack: () => {
                message.destroy();
                follow ? message.success('关注成功') : message.success('已取消关注');
                this.getList();
            }
        })
    }
    renderTable() {
        const { dataSource } = this.state;
        let {secondaryTabs,mediaType} =this.state;
        let newData = secondaryTabs&&secondaryTabs.length&&secondaryTabs.filter(item=> item.type === mediaType);
        let columns = [
                {
                    title: "标题",
                    dataIndex: "title",
                    width:600,
                    render: (text, record, index) => {
                        return <TitleAndPicReview
                            item={record}
                            mediaType={this.state.mediaType}
                            callBack={() => {
                                this.itemClick(record)
                            }}
                            collectionHandle={() => {this.collectionArticle(record)}}
                            >
                        </TitleAndPicReview>
                    }

                },
                {
                    title: "账号名称",
                    dataIndex: "positionName",
                    width:280,
                    render: (text, record, index) => {
                        return (
                            <div
                                style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-start'}}
                                onMouseEnter={() => {
                                    if (!record.follow) {
                                        document.getElementById(record.contentId).style.display = 'block';
                                    }
                                }}
                                onMouseLeave={() => {
                                    if (!record.follow) {
                                        document.getElementById(record.contentId).style.display = 'none';
                                    }
                                }}
                            >
                                <div style={{display: 'flex', alignItems: 'center', flex: 'auto',overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',}}>
                                    <img style={{ width: 15, objectFit: 'cover', marginRight: 5 }} src={newData ? newData[0].logo : ''} alt="" />
                                    <span>{text}</span>
                                </div>
                                <div style={{marginLeft: 10, display: record.follow ? 'block' : 'none', width: 80}} id={record.contentId}>
                                    {this.state.mediaType === 2 && (<span style={ record.follow ? { background: '#efad2a', color: '#fff' } : {}} id={`followedButton`} className='followButton' onMouseEnter={(e) => {
                                            if(record.follow) {
                                                e.target.innerText = '取消关注';
                                                e.target.style.color = '#000';
                                                e.target.style.background = '#f5f8fc';
                                            }
                                        }} onMouseLeave={(e) => {
                                            if(record.follow) {
                                                e.target.innerText = '已关注';
                                                e.target.style.color = '#fff';
                                                e.target.style.background = '#efad2a';
                                            }
                                        }} onClick={() => {
                                            if(record.follow) {
                                                this.followAccount(record.mediaCode, false);
                                            } else {
                                                this.followAccount(record.mediaCode, true);
                                            }
                                        }}>{record.follow ? '已关注' : '关注'}</span>
                                    )}
                                </div>
                            </div>
                        )
                    }
                },

            ];
        if([1, 2, 3, 5].includes(this.state.mediaType)){
            columns.push({
                title: "发布时间",
                dataIndex: "publishTime",
                width:172,
                render: (text, record, index) => {
                    return <div>{text?formatTime(text):''}</div>
                }
            });
        }else{
            columns.push({
                title: "录入时间",
                dataIndex: "publishTime",
                width:172,
                render: (text, record, index) => {
                    return <div>{text?formatTime(text):''}</div>
                }
            });
        }

        if (this.state.mediaType === 3 || this.state.mediaType === 5) {
            columns.push({
                title: '转评赞',
                dataIndex: 'count',
                ellipsis: true,
                width: 172,
                render: (text, record) => {
                    return (<div>{text ? formatCount(text) : "-"}</div>)
                }
            })
        } else if (this.state.mediaType === 2) {
            columns.push({
                title: "阅读数",
                dataIndex: "count",
                ellipsis: true,
                width: 100,
                render: (text, record) => {
                    return (<div>{text ? formatCount(text) : "-"}</div>)
                }
            });
        }

        columns.push({
            title: "主责单位",
            dataIndex: "createDeptName",
            width:172,
        });
        if(this.state.mediaType === 1 || this.state.mediaType === 2){
            columns.push({
                title: "操作",
                align:'left',
                width: 150,
                render: (text, record, index) => {
                    let btns = [];
                    if (this.state.mediaType === 2) {
                        let storyPicker = <Popover key={"storyPicker"}
                                content={<RenderPicker id={record.contentId} treeData={this.state.treeData} data={record}/>}
                                placement="bottomRight"
                            >
                                <Button size={'small'} type={'link'} className='aPopover' style={{padding: 0, background: "unset" }}>拾取至</Button>
                            </Popover>
                        if (this.permissionCheck("pms:contentManage:pickUp")) {
                            btns.push(storyPicker);
                        }
                        let downLoadBtn = <Button style={{padding: 0, marginLeft: btns.length && 10}} key='download' type='link' onClick={() => {
                                this.downLoad(record)
                            }}>下载</Button>;
                        btns.push(downLoadBtn);
                    } else {
                        let copyLink = <Button style={{padding: 0}} key="copyLink" type='link' onClick={() => {
                            this.copyText(record)
                        }}>复制链接</Button>
                        btns.push(copyLink);
                    }
                    // btns.push(<Button style={{padding: 0, marginLeft: btns.length && 10}} key='view' type='link' onClick={() => {
                    //     this.view(record)
                    // }}>查看</Button>)
                    return btns && btns.length ? btns.map(btn => btn): null
                }
            })
        }
        return (
            <PageTemplate style={{padding:'0px 15px 15px 15px',maxHeight: `calc(100vh - 100px - ${this.state.screenHeight-52}px)`}} styleOut={{marginTop:0}}>
                <Scrollbars autoHide autoHeight autoHeightMax={`calc(100vh - 310px - ${this.state.screenHeight-52}px)`} >
                <TableTemplate
                    // key={"TableTemplate" + this.state.mediaType}
                    dataSource={dataSource}
                    columns={columns}
                    onResize={()=>{}}
                />
                </Scrollbars>
                {this.state.dataSource&&this.state.dataSource.length? <PaginationTemplate
                    showQuickJumper={true}
                    total={this.state.count}
                    current={this.state.page}
                    pageSize ={this.state.size}
                    onShowSizeChange={this.onShowSizeChange}
                    onChange={this.onPageChange}
                    onResize={()=>{}}
                />:null}

            </PageTemplate>
        )
    }



}
/*
function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps)(ContentManagement);*/
